
// In src/components/search/TutorCard.tsx
import React, { useMemo } from 'react'; // Import useMemo
import { UserDetails } from '../../types/schemas/abc';
import {
  TutorCardWrapper,
  TutorImage,
  TutorInfo,
  TutorName,
  TutorCredentials,  // 👈 Import new component
  TutorDescription,
  TagWrap,
  Tag, // 👈 Import new component
  ProfileInitial, // 👈 1. Import the new styled component
} from '../../styles/search/search.style';
import { getFirstName, getInitial } from '../../utils/name';

interface ParentCardProps {
  tutor: UserDetails;
  parent: UserDetails;
}

export const ParentCard: React.FC<ParentCardProps> = ({ tutor, parent }) => {
  console.log(tutor);



  const tutorSubjectsSet = useMemo(() => {
    if (!tutor?.subjects) return new Set<string>();
  
    return new Set(tutor.subjects);
  }, [tutor?.subjects]);

  const initials = getInitial(parent.name);

  return (
    <TutorCardWrapper>
        <ProfileInitial style={{ backgroundColor: parent.profileColor || '#e0e0e0' }}>
          {initials}
        </ProfileInitial>
      <TutorInfo>
      <TutorName>
        {getFirstName(parent.name) || 'parent'}
        </TutorName>


        
        {parent.subjects && parent.subjects.length > 0 && (
          <TagWrap css={{ marginTop: 'auto', paddingTop: '0.5rem', width: '100%', marginLeft: 0, marginRight: 0 }}>
            {parent.subjects.map((subject) => {

              const isMatch = tutorSubjectsSet.has(subject);
              return (
              <Tag key={subject} isMatch={isMatch}>{subject}</Tag>
            )
            })}
          </TagWrap>
        )}

        {/* The description is also optional */}
        {parent.description && <TutorDescription>{parent.description}</TutorDescription>}
      </TutorInfo>
    </TutorCardWrapper>
  );
};